import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Select from '../../../components/ui/Select';

const BulkActionsBar = ({ selectedCount, onBulkAction, onCreateList }) => {
  const [showListCreator, setShowListCreator] = useState(false);
  const [listName, setListName] = useState('');

  const bulkActionOptions = [
    { value: 'email', label: 'Send Email Campaign' },
    { value: 'export', label: 'Export Selected' },
    { value: 'addToList', label: 'Add to Media List' },
    { value: 'updateStatus', label: 'Update Status' },
    { value: 'delete', label: 'Delete Contacts' }
  ];

  const handleBulkAction = (action) => {
    if (action === 'createList') {
      setShowListCreator(true);
    } else {
      onBulkAction(action);
    }
  };

  const handleCreateList = () => {
    if (listName?.trim()) {
      onCreateList(listName?.trim());
      setListName('');
      setShowListCreator(false);
    }
  };

  if (selectedCount === 0) {
    return null;
  }

  return (
    <div className="fixed bottom-6 left-1/2 transform -translate-x-1/2 z-50">
      <div className="bg-card border border-border rounded-lg shadow-elevated p-4 min-w-96">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-3">
            <div className="flex items-center space-x-2">
              <Icon name="CheckCircle" size={20} className="text-primary" />
              <span className="font-medium text-foreground">
                {selectedCount} contact{selectedCount !== 1 ? 's' : ''} selected
              </span>
            </div>
          </div>
          
          <div className="flex items-center space-x-2">
            {!showListCreator ? (
              <>
                <Button
                  variant="outline"
                  size="sm"
                  onClick={() => handleBulkAction('createList')}
                  iconName="Plus"
                  iconPosition="left"
                >
                  Create List
                </Button>
                
                <Select
                  options={bulkActionOptions}
                  value=""
                  onChange={handleBulkAction}
                  placeholder="Bulk actions"
                  className="min-w-40"
                />
                
                <Button
                  variant="ghost"
                  size="sm"
                  onClick={() => onBulkAction('deselectAll')}
                  iconName="X"
                  iconPosition="left"
                >
                  Clear
                </Button>
              </>
            ) : (
              <div className="flex items-center space-x-2">
                <input
                  type="text"
                  placeholder="Enter list name..."
                  value={listName}
                  onChange={(e) => setListName(e?.target?.value)}
                  className="px-3 py-2 border border-border rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent"
                  onKeyPress={(e) => e?.key === 'Enter' && handleCreateList()}
                  autoFocus
                />
                <Button
                  variant="default"
                  size="sm"
                  onClick={handleCreateList}
                  disabled={!listName?.trim()}
                >
                  Create
                </Button>
                <Button
                  variant="ghost"
                  size="sm"
                  onClick={() => {
                    setShowListCreator(false);
                    setListName('');
                  }}
                >
                  Cancel
                </Button>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default BulkActionsBar;